/**
 * @Author:
 * @Date:   2019/04/17
 * @功能：
 */
/* eslint-disable */
// 注册函数使用
import { ref, watch } from 'vue';
const CALL_JS_CALLBACKS = {};
const REGISTER_CALLBACKS = ref([]);
// 暴露函数方法
export const nativeBridge = {
    init(bridge) {
        // this.bridge.init 方法多次调用，只初始化一次，否则会报错
        if (window.initWebViewJavascript) return;
        window.initWebViewJavascript = true;
        this.bridge = bridge;
        this.bridge.init && this.bridge.init();
        this.register();
        // 监听注册回调，等bridge加载完成，再调用函数
        watch(
            REGISTER_CALLBACKS,
            () => {
                for (let i = 0; i < REGISTER_CALLBACKS.value.length; i++) {
                    REGISTER_CALLBACKS.value[i]();
                    REGISTER_CALLBACKS.value[i].finished = true;
                }
            },
            {
                immediate: true,
                deep: true
            }
        );
    },
    register: () => {
        // console.log('onGetSongInfo 注册');
        const bridge = nativeBridge.bridge || window.WebViewJavascriptBridge;
        bridge.registerHandler('callJs', function (res, callback) {
            const data = typeof res === 'string' ? JSON.parse(res) : res;
            if (nativeBridge.jsFunc[data.opt]) {
                nativeBridge.jsFunc[data.opt](data, callback);
            } else {
                // todo: 后续需要上报错误信息
                // console.error('jsFunc error! data.opt: ', data.opt);
            }
        });

        bridge.registerHandler('pageActive', function (res, callback) {
            // console.log('pageActive');
        });
    },
    jsFunc: {},
    /**
     * 调用native的方法
     * @param name
     * @param data
     * @param func
     * @param phase
     * @returns {Promise}
     */
    callNativeFunc: (name, data = {}, func, phase) => {
        return new Promise((resolve, reject) => {
            try {
                // console.log('SDK调用开始', name);
                Promise.race([nativeBridge.bridgeHandle(name, data)])
                    .then((response) => {
                        const resData =
                            typeof response === 'string' ? JSON.parse(response) : response;
                        try {
                            // 支持 callback 和 promise
                            if (func) {
                                func(resData)
                                    .then((res) => {
                                        // debug
                                        // console.log('回调执行成功', name, res);
                                        resolve(res);
                                    })
                                    .catch((e) => {
                                        // console.log('native回调报错', e, name);
                                    });
                            } else {
                                resolve(resData);
                            }
                        } catch (e) {
                            // console.log('native回调报错', e, name);
                        }
                    })
                    .catch((e) => {
                        reject(e);
                    });
                // 处理回调参数类型
            } catch (e) {
                // debug
                const data = e.message ? e.message : e;
                // console.log('调用SDK出错', name, data);
            }
        });
    },
    bridgeHandle: (name, data = {}) => {
        return new Promise((resolve, reject) => {
            try {
                const bridge = nativeBridge.bridge || window.WebViewJavascriptBridge;
                // console.log('bridge', name);
                if (!bridge) {
                    resolve(false);
                    return;
                }
                bridge.callHandler('callNative', { opt: name, data: data }, (param) => {
                    // console.log('SDK调用成功', name);
                    resolve(param);
                });
            } catch (e) {
                reject(e);
            }
        });
    },
    noSupportVersion() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({ errcode: 999, errmsg: '为保障您的体验，请保持版本为最新' });
            }, 5000);
        });
    }
};

const tnative = {
    // call js methods
    registerCallJsMethods(opt, cb) {
        CALL_JS_CALLBACKS[opt] = cb;
        // console.log(CALL_JS_CALLBACKS, 'CALL_JS_CALLBACKS');
    },
    requestSign: (data, callback) => nativeBridge.callNativeFunc('requestSign', data, callback) // 接口加密
};

/**
 * 启动 bridge 函数
 * @returns {number|*}
 */
export function setupWebViewJavascriptBridge() {
    const callback = (bridge) => {
        console.log('init ios');
        nativeBridge.init(bridge);
    };
    if (window.WebViewJavascriptBridge) {
        console.log('ios go');
        return new Promise((resolve, reject) => {
            try {
                callback(WebViewJavascriptBridge);
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }
    // window.initWebViewJavascript = true;
    if (window.WVJBCallbacks) {
        return new Promise((resolve, reject) => {
            try {
                window.WVJBCallbacks.push(callback);
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }
    window.WVJBCallbacks = [callback];
    return /iPhone|iPad|ios/gi.test(window.navigator.userAgent)
        ? ojcBridgeLoaded()
        : andBridgeLoaded(callback);
}

/**
 * Ios bridge loaded
 */
function ojcBridgeLoaded() {
    return new Promise((resolve, reject) => {
        try {
            console.log('执行ios');
            let WVJBIframe = document.createElement('iframe');
            WVJBIframe.style.display = 'none';
            WVJBIframe.src = 'https://__bridge_loaded__?t=' + Date.now();
            document.documentElement.appendChild(WVJBIframe);
            setTimeout(function () {
                document.documentElement.removeChild(WVJBIframe);
                WVJBIframe = null;
                resolve();
            }, 300);
        } catch (error) {
            // console.log(error);
            reject(error);
        }
    });
}

/**
 * Android bridge loaded
 */
function andBridgeLoaded(callback) {
    return new Promise((resolve, reject) => {
        try {
            if (window.WebViewJavascriptBridge) {
                callback(WebViewJavascriptBridge);
                resolve();
            } else {
                document.addEventListener(
                    'WebViewJavascriptBridgeReady',
                    function () {
                        callback(WebViewJavascriptBridge);
                        resolve();
                    },
                    false
                );
            }
        } catch (error) {
            reject(error);
        }
    });
}
export const callJsRegister = (callback = []) => {
    for (let i = 0; i < REGISTER_CALLBACKS.value.length; i++) {
        const _call = REGISTER_CALLBACKS.value[i];
        if (!_call.finished) callback.unshift(_call);
    }
    REGISTER_CALLBACKS.value = callback;
};
// 启动bridge
// setupWebViewJavascriptBridge().then(() => {
//     console.log('init bridge完成 native');
// });

console.log('native init', Date.now());
export default tnative;
